const Functions: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8.75 0.333344H1.3C0.583333 0.333344 0 0.916677 0 1.63334C0 1.86668 0.1 2.09168 0.266667 2.25001L5.41667 7.00001L0.266667 11.75C0.1 11.9083 0 12.1333 0 12.3667C0 13.0833 0.583333 13.6667 1.3 13.6667H8.75C9.44167 13.6667 10 13.1083 10 12.4167C10 11.725 9.44167 11.1667 8.75 11.1667H4.16667L7.15833 8.17501C7.80833 7.52501 7.80833 6.46668 7.15833 5.81668L4.16667 2.83334H8.75C9.44167 2.83334 10 2.27501 10 1.58334C10 0.891677 9.44167 0.333344 8.75 0.333344Z" fill="currentColor" />
  </svg>
);

export default Functions;
